import { render, staticRenderFns } from "./pix-qr-code-loader.vue?vue&type=template&id=40a9d704&scoped=true&"
import script from "./pix-qr-code-loader.vue?vue&type=script&lang=js&"
export * from "./pix-qr-code-loader.vue?vue&type=script&lang=js&"
import style0 from "./pix-qr-code-loader.vue?vue&type=style&index=0&id=40a9d704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9d704",
  null
  
)

export default component.exports